import { Button } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

export const NotifyPeopleTriggerButton = ({
  values,
  isDisabled = false,
  ...props
}) => (
  <Button
    dataTestId="user-targeting-button"
    icon={() => (
      <FontAwesomeIcon
        iconName="bell"
        height="16px"
        iconType={CATEGORIES.SOLID}
      />
    )}
    isDisabled={isDisabled}
    variant="secondary"
    {...props}
  >
    {__('Notify people')}
    {values?.targeted_user_ids?.length > 0 &&
      ` · ${values.targeted_user_ids.length}`}
  </Button>
);
